var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('router-link',{staticClass:"link",attrs:{"to":{ name: _vm.link, params: _vm.params}},nativeOn:{"click":function($event){return $event.stopImmediatePropagation()}}},[_vm._v(" "+_vm._s(_vm.title)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }